import * as React from 'react'
import {
    Table,
    Thead,
    Tr,
    Th,
    Tbody,
    Td,
    TableVariant
} from '@patternfly/react-table';
import {
    ResourceItem,
    ResourceItemType
} from '@app/components/ResourceItem'

import { SecretVariable } from '@app/SecretManager/SecretsExplorer/model/repository'
import { Link, useRouteMatch } from 'react-router-dom';


const VariablesTable: React.FunctionComponent<{ variables: SecretVariable[], root: string }> = ({ variables, root }) => {


    const table_body = (variables: SecretVariable[]) => {
        return variables.map(variable => {
            const secret_provider = `${variable.secret_provider_key_ref.secret_provider_name}/${variable.secret_provider_key_ref.secret_provider_key}`;
            const keyvault = `${variable.keyvault_key_ref.keyvault_name}/${variable.keyvault_key_ref.keyvault_key}`;
            const secret_name =  `${variable.name}`;
            const { url } = useRouteMatch<{ url: string }>();

            return (
                <Tr key={variable.name}>
                    <Td>
                        <ResourceItem type={ResourceItemType.Secret}>
                            <Link to={`${url}/variable/${secret_name}`}>{secret_name}</Link>
                        </ResourceItem>
                    </Td>
                    <Td>{keyvault}</Td>
                </Tr>
            );
        })
    }

    return <Table variant={TableVariant.compact}>
            <Thead>
                <Tr>
                    <Th width={50}>Name</Th>
                    <Th>Keyvault</Th>
                </Tr>
            </Thead>
            <Tbody>{table_body(variables)}</Tbody>
        </Table>
   
}

export { VariablesTable }